module.exports = __webpack_public_path__ + "img/woman.9ec04c6.jpg";